import React from "react";
import {
  Grid,
  Card,
  CardContent,
  CardMedia,
  Box,
  Button,
  Chip,
} from "@mui/material";
import Carousel from "react-material-ui-carousel";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Paper } from "@mui/material";
import { Tooltip } from "@mui/material";
import { teal } from "@mui/material/colors";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import { organs } from "../../Environment/Config";
import { MstaButton } from "../../Functions/Style/ButtonStyle";
import { MstaFontFamily } from "../../Functions/Style/MstaFont";
import { useWindowDimensions } from "../../Functions/ScreenOperation/useWindowDimension";
import { getKeyImageUrl } from "../../Functions/APIservice/useStorage";
import { db } from "../../Environment/firebase";
import firebase from "firebase/compat/app";
import { DocumentData } from "firebase/firestore";
import CatalogueContents from "../../Pages/Catalogue/CatalogueContents";
export type CaseCardType = {
  id: string;
  title: string;
  age: string;
  sex: string;
  patientId: string;
  site: string;
  modality: string;
  date: string;
  organTags: string[];
  keyImages: string[];
  casenumber?: number;
  publishDate?: firebase.firestore.Timestamp; // ← ここを追加！
};

export default function CaseCard(props: CaseCardType) {
  const uploaderId = "df0090fb-934e-11ee-96c4-f938a98198c2";

  const [update, setUpdate] = React.useState(false);

  const patientId = props.id; // DiseaseId or CatalogueId
  const { width, height } = useWindowDimensions();

  const organTags = organs.filter((organ) =>
    props.organTags.includes(organ.name)
  );
  var organTagImages = organTags.map((organTag) => {
    return { alt: organTag.alt, src: organTag.src };
  });
  const organImages = organTagImages.filter(
    (element, index, self) =>
      self.findIndex((e) => e.src === element.src) === index
  );
  organImages.sort((a, b) => {
    if (a.alt < b.alt) {
      return -1;
    }
    if (a.alt > b.alt) {
      return 1;
    }
    // 名前が等しい
    return 0;
  });

  const navigate = useNavigate();

  const intervalMs = 1000;

  function textTrim(
    targetTextArr: string | string[],
    wordCount = width > 450 ? 24 : 15
  ) {
    // テキストをトリミングする要素
    if (targetTextArr) {
      let selector;
      if (typeof targetTextArr === "string") {
        selector = targetTextArr;
      } else {
        selector = targetTextArr.join(",");
      }

      // 文末に追加したい文字
      var clamp = "…";

      if (selector.length > wordCount) {
        selector = selector.slice(0, wordCount - 1);
        selector += clamp;
      }

      return selector;
    } else {
      return targetTextArr;
    }
  }

  function extractTitles(str: string): string[] {
    const titles = str.split(/#|\s+/).filter((term) => term !== "");
    return titles;
  }

  // 副作用フック
  React.useEffect(() => {
    const intervalId = setInterval(() => {
      // 定期実行する関数
      setUpdate(!update);
    }, intervalMs);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const [imageData, setImageData] = React.useState<string[]>([]);

  type CatalogueContentsBaseType = {
    catalogueData: firebase.firestore.DocumentData;
  };

  React.useEffect(() => {
    const fetchKeyImages = async () => {
      const keyImageDatasPromises: Promise<string>[] = props.keyImages.map(
        async (item) => {
          const urlResult = await getKeyImageUrl(
            `gs://mnes-mnist-imagestudy.appspot.com/KeyImage/${patientId}/${item}`
          );
          return urlResult;
        }
      );

      // Promise.all(keyImageDatasPromises).then((result) => setImageData(result));

      const keyImageDatas = await Promise.all(keyImageDatasPromises);
      setImageData(keyImageDatas);
    };

    fetchKeyImages();
  }, [patientId]);

  const isNew = () => {
    if (
      !props.publishDate ||
      !(props.publishDate instanceof firebase.firestore.Timestamp)
    ) {
      return false;
    }
    const publishedDate = props.publishDate.toDate(); // JSのDate型に変換
    const now = new Date();
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(now.getDate() - 7);
    return publishedDate > oneWeekAgo;
  };

  return (
    <Card
      sx={{
        height: 350,
        display: "flex",
        border: 2,
        alignItems: "center",
        "&:hover": { cursor: "pointer" },
      }}
      onClick={() => {
        window.open(`/catalogue/case/${uploaderId}/${props.id}`, "_blank");
      }}
    >
      <Grid container height={300} justifyContent={"space-between"}>
        <Grid
          item
          xs={7}
          md={6}
          display="flex"
          flexDirection="column"
          alignItems={"flex-start"}
          justifyContent={"space-between"}
          gap={2}
        >
          <CardContent>
            <Grid display="flex" alignItems="center" justifyContent="start">
              <Typography
                variant="h6"
                color="textSecondary"
                fontSize={20}
                fontWeight={300}
                fontFamily={MstaFontFamily}
              >
                {props.age + "代"}
              </Typography>
              <Typography
                variant="h6"
                color="textSecondary"
                fontSize={20}
                fontWeight={300}
                fontFamily={MstaFontFamily}
              >
                /
              </Typography>
              <Typography
                variant="h6"
                color="textSecondary"
                fontSize={20}
                fontWeight={300}
                fontFamily={MstaFontFamily}
              >
                {props.sex === "1"
                  ? "男性"
                  : props.sex === "2"
                  ? "女性"
                  : "不明"}
              </Typography>
              <Typography
                variant="h6"
                color="textSecondary"
                fontSize={20}
                fontWeight={300}
                fontFamily={MstaFontFamily}
              >
                /
              </Typography>
              <Typography
                variant="h6"
                color="textSecondary"
                fontSize={20}
                fontWeight={300}
                fontFamily={MstaFontFamily}
              >
                {props.modality}
              </Typography>
            </Grid>

            {extractTitles(props.title)
              .slice(0, 5)
              .map((title, index) => (
                <Tooltip title={title}>
                  <Typography
                    key={index} // リスト内の要素には一意のキーを設定
                    variant="h6"
                    color="text.primary"
                    textAlign="left"
                    fontFamily={MstaFontFamily}
                    fontWeight={600}
                    className="title"
                    sx={{
                      fontSize: { xs: 20, md: 20 },
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 1,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    #{title}
                  </Typography>
                </Tooltip>
              ))}
          </CardContent>
          <Grid display={"flex"}>
            <Typography
              variant="h6"
              textAlign="left"
              fontFamily={MstaFontFamily}
              fontWeight={600}
              className="casenumber"
              ml={2}
              sx={{ color: "rgba(0, 0, 0, 0.3)" }}
            >
              症例番号{props.casenumber ?? "なし"}
            </Typography>
            {isNew() && (
              <Chip
                label="New"
                sx={{
                  backgroundColor: "#FF22D6", // MUIのピンク系（pink[300]）
                  color: "#fff", // 白文字にして視認性アップ
                  fontWeight: "bold",
                  ml: 2,
                }}
              />
            )}
          </Grid>
        </Grid>

        {/* <MstaButton
            className="lectureMenuButton"
            size="small"
            sx={{
              mb: { md: 2, xs: 1 },
              height: { xs: 30, md: 60 },
              fontSize: { xs: 12, md: 20 },
            }}
            onClick={() => {
              window.open(`/catalogue/${uploaderId}/${props.id}`, "_blank");
            }}
          >
            画像を見る
          </MstaButton> */}

        <Grid
          item
          xs={5}
          md={5}
          display={"flex"}
          justifyContent={"flex-end"}
          alignItems={"center"}
          onClick={(event) => {
            event.stopPropagation(); // Carousel内でクリックイベントを伝播させない
          }}
        >
          <Carousel sx={{ width: "100%", mr: 2 }}>
            {imageData.map((item, i) => (
              <CardMedia
                key={i}
                // sx={{
                //   mt: 2,
                //   mb: 2,
                //   ml: 2,
                // }}
                component="img"
                image={item}

                // alt={`Image ${currentIndex + 1}`}
              />
            ))}
          </Carousel>
        </Grid>
      </Grid>
      {/* {card.image ? (
        <CardMedia
          component="img"
          sx={{
            height: { md: 180, xs: 100 },
            width: { md: 180, xs: 100 },
            mr: 2,
          }}
          image={card.image}
          alt="random"
        />
      ) : (
        <div></div>
      )} */}
    </Card>
  );
  // return (
  //     <Paper elevation={3}

  //     sx={{ width: width>450? 430:400,
  //         height: 250,
  //         border:1,
  //         p:2,
  //          }} >
  //         <Tooltip title={props.title || ''}>
  //             <Typography variant="h6"
  //                     color="text.primary"
  //                     textAlign="left"
  //                     fontSize={18}
  //                     fontFamily={MstaFontFamily}
  //                     fontWeight={600}
  //                     className="title"
  //                     sx={{textDecoration: 'underline'}}
  //                 >
  //                     {textTrim(props.title || props.patientId)}
  //             </Typography>
  //         </Tooltip>
  //         <Grid display={'grid'}

  //         >
  //             <Grid item display={'flex'}
  //                     alignItems={'center'}
  //                     justifyContent={'center'}
  //                     gap={2}
  //                     pt={1}
  //                     >
  //                 <Typography variant="h5"
  //                     color="text.primary"
  //                     fontSize={20}
  //                     fontWeight={300}
  //                     fontFamily={MstaFontFamily}
  //                 >
  //                     {props.age + '代'}
  //                 </Typography>
  //                 <Typography variant="h5"
  //                     color="text.primary"
  //                     fontSize={20}
  //                     fontWeight={300}
  //                     fontFamily={MstaFontFamily}
  //                 >
  //                     /
  //                 </Typography>
  //                 <Typography variant="h5"
  //                     color="text.primary"
  //                     fontSize={20}
  //                     fontWeight={300}
  //                     fontFamily={MstaFontFamily}
  //                 >
  //                     {props.sex === '1'?'男性':props.sex ==="2"?'女性':'不明'}
  //                 </Typography>
  //                 <Typography variant="h5"
  //                     color="text.primary"
  //                     fontSize={20}
  //                     fontWeight={300}
  //                     fontFamily={MstaFontFamily}
  //                 >
  //                     /
  //                 </Typography>
  //                 <Typography variant="h5"
  //                     color="text.primary"
  //                     fontSize={20}
  //                     fontWeight={300}
  //                     fontFamily={MstaFontFamily}
  //                 >
  //                     {props.modality}
  //                 </Typography>
  //             </Grid>
  //             <Grid item alignItems="start"
  //                     justifyContent="space-around"
  //                     display={'grid'}
  //                     gridTemplateColumns={"40px 40px 40px 40px"}
  //                     height={100}
  //                     sx={{mt:2}}
  //                    >
  //                 {organImages.map(organImage=>(
  //                     <Grid key={organImage.alt}>
  //                         <img alt={organImage.alt} src={organImage.src}
  //                         style={{height:"40px",width:"40px"}}
  //                         ></img>
  //                     </Grid>
  //                 ))}
  //             </Grid>
  //             <Grid justifyContent={'center'}>
  //                 < MstaButton sx={{width:150}}
  //                     onClick={()=>{
  //                         window.open(`/catalogue/${uploaderId}/${props.id}`,'_blank')
  //                     }}>
  //                     画像を見る
  //                 </>
  //             </Grid>

  //         </Grid>
  //     </Paper>
  // )
}

//<ImageNotSupportedIcon sx={{fontSize:80}}></ImageNotSupportedIcon>
